<script setup lang="ts">
defineOptions({ inheritAttrs: false })

const props = defineProps<{
  class?: string;
}>()

const sectionClasses = computed(() => {
  return twMerge('py-16 md:min-h-dvh', props.class)
})
</script>

<template>
  <section
    v-bind="$attrs"
    :class="sectionClasses"
  >
    <slot />
  </section>
</template>
